export const WidgetTypes = {
  HEADER: 'header',
  ALERT: 'alert',
  STRING: 'string',
  PHONE: 'phone',
  NUMBER: 'number',
  DECIMAL: 'decimal',
  RADIOGROUP: 'radiogroup',
  CHECKBOXGROUP: 'checkboxgroup',
  HIDDENSTRING: 'hiddenstring',
  GROUP: 'group',
  SELECT: 'select',
  COMBOBOX: 'combobox',
  DATE: 'date',
  BOOLEAN: 'boolean',
  RADIOBUTTON: 'radiobutton',
  IMAGE: 'image',
  HTML: 'html',
  PRICE: 'price',
  USEDCARGUARANTEE: 'usedcarguarantee',
  MODELANDMAKE: 'model_and_make',
  EQUIPMENT: 'equipment',
  CONDITION: 'condition',
  PROFILE: 'profile',
  COUNTRY: 'country',
  LEASINGTERMINATION: 'leasingtermination',
  TEXTAREA: 'textarea',
  STREET: 'street',
  POSTALCODE: 'postalcode',
  YESNO: 'yesno',
} as const;
